import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateUserProfilePhoto } from '../../store/actions';

function ProfilePhotoDropdown(props) {
  const { t } = useTranslation();
  const uploadButtonRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleDropDownClick = async (option) => {
    if (option === 'remove') {
      await props.handleFile();
      await props.updateUserProfilePhoto(
        props.userId,
        props.auth.jwtToken,
        null
      );
    }
  };

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        /* Don't close the dropdown if the click occurred on:
          - the photo menu (to avoid unexpected closing while interacting with the menu)
          - or the plus icon button that opens/closes this dropdown (to avoid negating the effect of clicking on the button)
          - or the profile image that opens/closes this dropdown (to avoid negating the effect of clicking on the image)
        */
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !event.target.closest('#edit-profile-menu') &&
          !event.target.closest('.user-dashboard-profile-photo')
        ) {
          props.editProfilePic();
        }
      }

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      handleDropDownClick('upload');
      props.handleFile(fileUploaded);
    }
  };

  const handleClick = () => {
    if (uploadButtonRef.current) {
      uploadButtonRef.current.click();
    }
  };

  useOutsideAlerter(wrapperRef);

  return (
    <div className="dropdown is-active profile-photo-dropdown-container">
      <div className="dropdown-trigger">
        <button className="button profile-photo-dropdown-trigger" type="button">
          <span className="icon is-small">
            <i className="fas fa-angle-down" aria-hidden="true" />
          </span>
        </button>
      </div>
      <div className="dropdown-menu" id="dropdown-menu2">
        {props.editProfilePhoto && (
          <>
            <input
              type="file"
              name="file"
              onChange={handleChange}
              ref={uploadButtonRef}
              style={{ display: 'none' }}
            />
            <div className="dropdown-content" ref={wrapperRef} role="menu">
              <button
                className="profile-photo-dropdown-button"
                onClick={handleClick}
                onTouchStart={handleClick}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) return () => handleClick();
                }}
                type="button"
                role="menuitem"
              >
                {t('Upload a Photo')}
              </button>
              <hr className="dropdown-divider" />
              <button
                className="profile-photo-dropdown-button"
                onClick={() => handleDropDownClick('remove')}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key))
                    return () => handleDropDownClick('remove');
                }}
                type="button"
                role="menuitem"
              >
                {t('Remove Photo')}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default connect(null, { updateUserProfilePhoto })(ProfilePhotoDropdown);
